module.exports = __webpack_public_path__ + "img/collect_pic_12.c07ded72.png";